import React, { useRef } from 'react';
import { useAuthContext } from 'jsx/auth/AuthProviderV2';
import { Root, MainContent, Header, Footer, Sidebar } from 'jsx/layout';
import {
  useRemoveInitApp,
  useSidebarProducts,
  useTranslationApi,
  useToggle,
  useRoleAccess
} from 'jsx/hooks';
import { UserMenu } from 'components/UserMenu';
import Section from 'jsx/elements/section/Section';
import { RoutesWithAccess } from './RoutesWithAccess';
import { RoutesWithoutAccess } from './RoutesWithoutAccess';
import { SIDEBAR_LOAN_FREEZE } from 'constants/sidebarProducts';
import { useTopProducts } from 'hooks';

export function App() {
  const [sidebarOpen, toggleSidebar] = useToggle(true);
  const [userMenuOpen, toggleUserMenu] = useToggle();
  const loaded = useTranslationApi(2015);
  useRemoveInitApp(loaded);
  const { user } = useAuthContext();
  const sidebarProducts = useSidebarProducts(860, sidebarProducts);
  const topProducts = useTopProducts();
  const hasProductAccess = useRoleAccess(860);
  const contentRef = useRef();
  if (!loaded) return null;

  return (
    <Root sidebarOpen={sidebarOpen}>
      <Header
        products={topProducts}
        mainText={user.name}
        subText={user.s_name}
        showMobileNav
        toggleSidebar={toggleSidebar}
        toggleUserMenu={toggleUserMenu}
        userMenu={<UserMenu open={userMenuOpen} toggleMenu={toggleUserMenu} />}
      />
      <MainContent>
        <Section ref={contentRef}>
          {hasProductAccess ? <RoutesWithAccess /> : <RoutesWithoutAccess />}
        </Section>
      </MainContent>
      <Footer />
      <Sidebar
        products={sidebarProducts}
        toggleExpanded={toggleSidebar}
        isExpanded={sidebarOpen}
        showNested={true}
      />
    </Root>
  );
}
